import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormTitle from "../../../../library/form/components/FormTitle";
import RolePrivilegeRow from './RolePrivilegeRow'
import { UiView, UiViewHeading, UiTitle } from "../../../../library/layout/Index";

const RoleDocumentRow = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null)

    return (
        <UiView className="uiSpacer20">
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Assigned Privileges' />
                </UiTitle>
                <div className="uiSpacerH10">
                    <FormButton formObject={formObject} ksc="ctrl+a" rowKey=""
                        action={{ actionId: "new",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Add New" />}></FormButton>
                </div>
            </UiViewHeading>
            <div className="listItemDetails">
                <ul style={{"width":"100%", "display": "flex", "flexWrap": "wrap"}}>
                    {
                        Object.values(viewData).map((row, index) => (
                            <li className="uiSpacer15 uiColumns300">
                                <RolePrivilegeRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                            </li>
                        ))
                    }
                </ul>
            </div>
        </UiView>

    )
}

export default withView(RoleDocumentRow, "rolePrivilege", "rolePrivilege")